import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices/DomainServicesContext";

import {
  CollectionRecord,
  CollectionResourceRef,
  CollectionResourceType,
} from "../CollectionRecord";

import { collectionQueryKeys } from "./collectionQueryKeys";

interface CreateCollectionVariables {
  orgId: string;
  name: string;
  description?: string;
  tags?: string[];
  resourceType: CollectionResourceType;
  resources?: CollectionResourceRef[];
  customFields?: Record<string, unknown>;
}

export function useCreateCollection() {
  const { collections } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<CollectionRecord, Error, CreateCollectionVariables>({
    mutationFn: ({
      orgId,
      name,
      description,
      tags,
      resourceType,
      resources,
      customFields,
    }) =>
      collections.createCollection(
        {
          name,
          description,
          tags,
          resource_type: resourceType,
          resources,
          custom_fields: customFields,
        },
        { orgId, resourceOwnerId: orgId },
      ),
    onSuccess: (record) => {
      queryClient.setQueryData(
        collectionQueryKeys.detail(record.collection_id),
        record,
      );
      void queryClient.invalidateQueries({
        queryKey: collectionQueryKeys.lists(record.org_id),
      });
    },
  });
}
